import { Col, Row } from 'antd';
import React from 'react';
import { capitalize } from '../../../../../../utils/helpFunctions';

export default function WhiteLabelFields({ data, theme, criiptoButtonsStyles }) {
    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Theme
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {theme?.name || '-'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Criipto colors
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            {criiptoButtonsStyles
                                ? capitalize(criiptoButtonsStyles)
                                : 'Default'}
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Graphic colors
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.light ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Light
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.graphic_colors?.light || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.graphic_colors?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.graphic_colors?.dark ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Dark
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.graphic_colors?.dark || '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Primary button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button?.hover || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button?.active || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <span className="details-table__color-value">
                                        {!!data?.primary_button?.outlined
                                            ? 'Yes'
                                            : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Primary button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button_content
                                            ?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button_content?.hover ||
                                            '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.primary_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.primary_button_content?.active ||
                                            '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Secondary button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button?.hover || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button?.active || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <span className="details-table__color-value">
                                        {!!data?.secondary_button?.outlined
                                            ? 'Yes'
                                            : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Secondary button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button_content
                                            ?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button_content
                                            ?.hover || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.secondary_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.secondary_button_content
                                            ?.active || '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Links
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.links?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.links?.hover || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.links?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.links?.active || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Underlined
                                    </span>
                                    <span className="details-table__color-value">
                                        {!!data?.links?.underlined
                                            ? 'Yes'
                                            : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Icons
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper"></div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.icons?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.icons?.hover || '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Selectors
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.selectors?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.selectors?.active || '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Email button
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.default ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button?.default || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.hover ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button?.hover || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button?.active ||
                                                'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button?.active || '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <span className="details-table__color-title">
                                        Outlined
                                    </span>
                                    <span className="details-table__color-value">
                                        {!!data?.email_button?.outlined
                                            ? 'Yes'
                                            : 'No'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Email button content
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell">
                            <div className="details-table__cell--inner-grid">
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.default || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Default
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button_content?.default ||
                                            '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.hover || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Hover
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button_content?.hover ||
                                            '-'}
                                    </span>
                                </div>
                                <div className="details-table__cell-element-wrapper">
                                    <div
                                        className="details-table__color-box"
                                        style={{
                                            backgroundColor: `#${
                                                data?.email_button_content
                                                    ?.active || 'FFFFFF'
                                            }`,
                                        }}
                                    ></div>
                                    <span className="details-table__color-title">
                                        Active
                                    </span>
                                    <span className="details-table__color-value">
                                        {data?.email_button_content?.active ||
                                            '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
